import Backbone from 'backbone'
import _ from 'underscore'
import NavItemViewTemplate from '../templates/nav-item.tpl'
import TitleCase from '../helpers/title-case'
import config from '../config'

const NavItemView = Backbone.View.extend({
    tagName: 'li',
    id: 'nav-item-view',
    events: {
        'click': 'navigate',
    },
    initialize() {
        this.template = _.template(NavItemViewTemplate)
        this.listenTo(this.model, 'change', this.render)
    },
    render() {
        const currentFragment = Backbone.history.fragment
        let isActive = false

        if (this.model.get('name') === 'contents') {
            // Check if the fragment matches "app/:slug"
            isActive = /^app\/[^/]+$/.test(currentFragment);
        } else if (this.model.get('name') === 'reporting') {
            // Check if the fragment matches "app/:slug/reporting"
            isActive = /^app\/[^/]+\/reporting$/.test(currentFragment)
        } else {
            isActive = this.model.get('url') === currentFragment
        }

        if (isActive) {
            this.$el.addClass('active')
        } else {
            this.$el.removeClass('active')
        }

        this.$el.html(this.template({
            name: this.model.get('name'),
            title: TitleCase(this.model.get('name'))
        }));

        return this;
    },
    navigate() {
        const slug = config.get('slug')

        // if this is app
        if (this.model.get('name') === 'contents') {
            Backbone.history.navigate(`app/${slug}`, {trigger: true})
            return
        }

        // if this is reporting
        if (this.model.get('name') === 'reporting') {
            Backbone.history.navigate(`app/${slug}/reporting`, {trigger: true})
            return
        }

        // if this is help
        if (this.model.get('name') === 'help') {
            window.open(config.get('helpLink'), '_blank')
            return
        }

        Backbone.history.navigate(this.model.get('url'), { trigger: true })
    }
})

export default NavItemView
